import { Location } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../auth/services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private router: Router,
    public location: Location
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let retryingAfterRefresh = false;
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !retryingAfterRefresh) {
          return from(this.authService.refreshAsync()).pipe(
            switchMap((token: any) => {
              if (token.accessToken) {
                retryingAfterRefresh = true;
                const clonedRequest = req.clone({
                  setHeaders: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    Authorization: `Bearer ${token.accessToken}`,
                  },
                });
                return next.handle(clonedRequest);
              } else {
                this.authService.logout();
                return next.handle(req);
              }
            }),
            catchError((err) => {
              this.authService.logout();
              return next.handle(req);
            })
          );
        }

        if (error.status === 401 && retryingAfterRefresh) {
          this.authService.logout();
          return next.handle(req);
        }

        if (error instanceof HttpErrorResponse && error.status === 0) {
          const message =
            'The server is not available. Please try again later or contact an administrator';
          this.notificationService.show(message, { type: 'error' });
          return next.handle(req);
        } else if (error instanceof HttpErrorResponse) {
          const message =
            error.error?.errors?.length > 0
              ? error.error.errors[0]
              : 'Something went wrong. Please try again later or contact an administrator';
          this.notificationService.show(message, { type: 'error' });
          return next.handle(req);
        } else {
          return next.handle(req);
        }
      })
    );
  }
}
